import { AuthConfig } from '@auth0/auth0-angular';

const authConfig = {
    domain: 'login.auth-poc.datax.ai',
    clientId: 'P7nRKZuRVdq0pIKOnrfK5OQ9ea4DntPS',
    useRefreshTokens: true,
    authorizationParams: {
        redirect_uri: window.location.origin + '/app/loading',
        audience: 'https://hsm.dev.datax.ai',
        organization: 'org_rWbzcnUH4DTrmsKo',
    },
    cacheLocation: 'localstorage',
} satisfies AuthConfig;

export const environment = {
    production: false,
    auth: authConfig,
    default_return_url: 'https://hsm.taxonomy-dev.datax.ai/'
};